import { useUpdateSentiment } from '@/hooks/PlayerSessionControlHooks';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'motion/react';
import { useState } from 'react';
import FeelingMeter from '../../Controls/FeelingMeter';
import AnimatedFeelingAfter from '@/components/Animated/Backgrounds/AnimatedFeelingAfterBackground';

export default function FeelingAfter() {
  const updateSentiment = useUpdateSentiment();

  const [sentiment, setSentiment] = useState<number | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const submit = async () => {
    if (!sentiment) return;

    setLoading(true);
    await updateSentiment(sentiment, false);
    setLoading(false);
  };

  return (
    <>
      <AnimatedFeelingAfter />
      <div className="max-w-288">
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-[#20145F] font-bold text-4xl mb-24 text-center"
        >
          How do you feel?
        </motion.h1>
        <FeelingMeter sentiment={sentiment} setSentiment={setSentiment} />
        <button
          className="btn btn-lg btn-primary w-full mt-16"
          onClick={submit}
          disabled={loading || !sentiment}
        >
          Next
          {loading && <FontAwesomeIcon icon={faSpinner} className="ml-8" spin />}
        </button>
      </div>
    </>
  );
}
